module.exports = __webpack_public_path__ + "img/goback.90d7b4ef.svg";